import React, {createContext, useContext, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

const LastLocationContext = createContext(null);

export function LastLocationProvider({children}) {
  const location = useLocation();
  const last = useRef(null);
  const prev = useRef(null);
  useEffect(() => {
    prev.current = last.current;
    last.current = location;
  }, [location]);
  return (
    <LastLocationContext.Provider value={prev.current}>
      {children}
    </LastLocationContext.Provider>
  );
}

export function useLastLocation() {
  return useContext(LastLocationContext);
}
